import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "./Button";
import { setActiveForm } from "../../redux/Reducer/Admin/PartnerSlice";

const SelectedTab = ({ tabs, index }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(index);

  const handleTabClick = (index) => {
    setActiveTab(index);
    localStorage.setItem("activeTab", index); // Save active tab to localStorage

    // Dispatch action to switch form based on tab index
    if (index === 0) {
      dispatch(setActiveForm(null));
    } else if (index === 1) {
      dispatch(setActiveForm("doctor"));
    } else if (index === 2) {
      dispatch(setActiveForm("store"));
    }
  };

  return (
    <div className="w-full">
      <ul className="flex items-center gap-[10px] mb-4">
        {tabs?.map((tab, index) => (
          <li key={index} className="flex-1">
            <Button
              className={`text-[13px] capitalize rounded-[8px] w-full py-2 px-4 bg-primary-600 text-white h-[40px] ${
                activeTab === index
                  ? "bg-primary-700"
                  : "border-transparent text-secondary-600"
              }`}
              onClick={() => handleTabClick(index)}
            >
              {tab?.name}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SelectedTab;
